import { twMerge } from "tailwind-merge";
import { Button, ButtonProps } from "@shared/ui/Button";
import { ThemeType } from "@shared/types/style.types";

export type ActionButtonsGroupProps = {
  theme?: ThemeType;
  onSecondaryClick?: (() => Promise<void>) | (() => void);
  onPrimaryClick?: (() => Promise<void>) | (() => void);
  secondaryButtonText?: string;
  primaryButtonText?: string;
  isButtonsFullWidth?: boolean;
  primaryButtonProps?: ButtonProps;
  secondaryButtonProps?: ButtonProps;
  className?: string;
};

export const ActionButtonsGroup = ({
  theme = "light",
  onSecondaryClick,
  onPrimaryClick,
  secondaryButtonText,
  primaryButtonText,
  secondaryButtonProps,
  primaryButtonProps,
  className,
  isButtonsFullWidth = false,
}: ActionButtonsGroupProps) => {
  const isWithSecondaryButton = onSecondaryClick && secondaryButtonText;

  const isWithPrimaryButton = onPrimaryClick && primaryButtonText;

  const isWithButtons = isWithSecondaryButton || isWithPrimaryButton;

  if (!isWithButtons) return null;

  return (
    <div
      className={twMerge(
        "flex flex-col items-start gap-3 md:flex-row md:items-end",
        className
      )}
    >
      {isWithSecondaryButton && (
        <Button
          variant="secondary"
          theme={theme}
          onClick={onSecondaryClick}
          data-testid="action-buttons-group-secondary"
          className={twMerge(
            "md:size-max",
            isButtonsFullWidth && "w-full md:w-full",
            secondaryButtonProps?.className
          )}
          {...secondaryButtonProps}
        >
          {secondaryButtonText}
        </Button>
      )}
      {isWithPrimaryButton && (
        <Button
          theme={theme}
          onClick={onPrimaryClick}
          data-testid="action-buttons-group-primary"
          className={twMerge(
            "md:size-max",
            isButtonsFullWidth && "w-full md:w-full",
            primaryButtonProps?.className
          )}
          {...primaryButtonProps}
        >
          {primaryButtonText}
        </Button>
      )}
    </div>
  );
};

export default ActionButtonsGroup;
